export default {"src":"/_next/static/image/public/images/ic_additional_instructions.6076f1ee800e5af7158fe04f7e41d7c4.svg","height":24,"width":24};